import { RootState } from '..';

export const alertSettingsUserList = (state: RootState) =>
  state.alertSettingsUser.alertSettingsUserList;

export const error = (state: RootState) => state.alertSettingsUser.error;

export const action = (state: RootState) => state.alertSettingsUser.action;

export const status = (state: RootState) => state.alertSettingsUser.status;
